import React from 'react';
import './Guidelines.css';
import LibraryNavbar from '../../components/Library/LibraryNavbar';
import Footer from '../../components/Homepage/Footer/Footer';

const Guidelines = () => {
  React.useEffect(() => {
    // Set page title
    document.title = 'Library Guidelines - Rayalaseema University';
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  const guidelines = [
    "Silence to be maintained",
    "No discussion permitted inside the library",
    "Registration should be done to become a library member prior to using the library resources",
    "No personal belongings allowed inside the library",
    "Textbooks, printed materials and issued books are not allowed to be taken inside the library",
    "Using Cellular phones and audio instruments with or without speaker or headphone is strictly prohibited in the library premises.",
    "Enter your name and Sign in the register kept at the entrance counter before entering library",
    "Show the books and other materials which are being taken out of the library to the staff at the entrance counter.",
    "The librarian may recall any book from any member at any time and the member shall return the same immediately.",
    "Library borrower cards are not transferable. The borrower is responsible for the books borrowed on his/her card.",
    "Refreshment of any kind shall not be taken anywhere in the library premises"
  ];

  const circulationRules = [
    {
      title: "Circulation Issue System:",
      content: "Books will be issued on presentation of the library card along with the smart card. Students are instructed to check the books while borrowing and they will be responsible for any type of damage or mutilation noticed at the time of return."
    },
    {
      title: "Overdue Charges:",
      content: "Books will be issued to the students for 14 days only. In the last page slip is pasted and stamped mentioning the due date and the fine will be charged @ Re.1 per day per book from the due date till the book is returned to library."
    },
    {
      title: "Book Lost:",
      content: "If the books are lost, then the borrower shall replace the books of the same edition or latest edition or pay double cost of the book after getting permission from the officer in-charge of central library."
    },
    {
      title: "Care of library borrower cards:",
      content: "Take special care to maintain the library borrower cards. Do not fold, alter entries made on the cards, Members are responsible for the entire set of library borrower card issued to them."
    },
    {
      title: "Loss of cards:",
      content: "Loss of borrower card should be reported to the librarian in writing. After checking the borrowing register they will be issued a fresh replacement card on a payment of Rs 10/- per card."
    },
    {
      title: "Validity of cards:",
      content: "Library borrower cards are valid for the respective academic year only and fresh cards will be issued for each year. At the end of the academic year borrower cards shall be returned to the library."
    },
    {
      title: "No due Certificate:",
      content: "Each student shall obtain No dues certificate from the Central library after returning all the books issued, surrendering the borrower's cards and after paying outstanding dues, if any."
    }
  ];

  return (
    <div id="library-guidelines-page">
      {/* Library-specific Navigation */}
      <LibraryNavbar />
      
      <div className="library-guidelines-container">
        <div className="library-guidelines-header">
          <h1 className="library-guidelines-title">Library Guidelines</h1>
          <div className="library-guidelines-underline"></div>
        </div>

        <div className="library-guidelines-content">
          {/* General Guidelines Section */}
          <section className="library-guidelines-section">
            <h2 className="library-guidelines-section-title">General Rules and Regulations</h2>
            <ul className="library-guidelines-list">
              {guidelines.map((guideline, index) => (
                <li key={index} className="library-guidelines-item">
                  <span className="library-guidelines-bullet">•</span>
                  <span className="library-guidelines-text">{guideline}</span>
                </li>
              ))}
            </ul>
          </section>

          {/* Circulation Rules Section */}
          <section className="library-guidelines-section">
            <h2 className="library-guidelines-section-title">Circulation Rules and Procedures</h2>
            <div className="library-guidelines-circulation">
              {circulationRules.map((rule, index) => (
                <div key={index} className="library-guidelines-rule">
                  <h3 className="library-guidelines-rule-title">{rule.title}</h3>
                  <p className="library-guidelines-rule-content">{rule.content}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact Information */}
          <section className="library-guidelines-section">
            <div className="library-guidelines-contact">
              <p className="library-guidelines-contact-text">
                <strong>For more information, please contact the library staff.</strong>
              </p>
            </div>
          </section>
        </div>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Guidelines;